































































































































































import Vue from 'vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XDropdown, {
  OptionEntry,
} from '@/components/atoms/Dropdown/XDropdown.vue'
import prefectures from '@/packages/Prefectures'
import Panel from './Panel.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XZipInput from '@/components/atoms/Input/XZipInput.vue'
import { AgentSalesDestination } from '@/types/generated/graphql'
import { AddressResponse } from '@/mixin/zipcodeMixin'

import XTel from '@/components/atoms/Input/XTel.vue'
import { Destination } from '@/components/molecules/AgentDestination/PartnerAgentDestinationForm.vue'

export type Input = {
  firstName?: string
  lastName?: string
  firstNameKana?: string
  lastNameKana?: string
  zipCode?: string
  prefId?: string
  address1?: string
  address2?: string
  phone?: string
  email?: string
}

type Data = {
  input: Input
}

type Computed = {
  localValue: Input
  prefOptions: OptionEntry<number | undefined>[]
}

type Props = {
  value: Input
  selectedDestination: Destination
}

export const toInput = (destination: AgentSalesDestination): Input => {
  return {
    address1: destination.address.address1,
    address2: destination.address.address2 || undefined,
    zipCode: destination.address.zipCode.fullCode,
    prefId: destination.address.pref.id,
    firstName: destination.name.first,
    lastName: destination.name.last,
    firstNameKana: destination.nameKana.first,
    lastNameKana: destination.nameKana.last,
    phone: destination.phone,
    email: destination.email,
  }
}

export default Vue.extend<Data, {}, Computed, Props>({
  name: 'Recipient',
  components: {
    XButton,
    XFormLabel,
    XInput,
    XDropdown,
    XTel,
    Panel,
    XZipInput,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    selectedDestination: {
      type: Object,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', { ...this.value, ...value })
      },
    },
    prefOptions() {
      const options = prefectures().map((e) => {
        return { value: e.id, label: e.name }
      })

      const emptyOpt = { value: undefined, label: '' }
      return [emptyOpt, ...options]
    },
  },
  methods: {
    setAddress(address: AddressResponse) {
      this.localValue.prefId = String(address.prefId)
      this.localValue.address1 = address.locality + address.street
    },
    onClickPicker() {
      this.$emit('click:destinationPicker')
    },
  },
})
